import { RouteConstants } from "src/app/share/constants/routes.constants";

export function adminSideBarList(envType: string = 'SDEX') {
  let list: any[] = [
    {
      label: 'Organisations',
      roles: 'company.view',
      routerLink: '/admin/sdex/company',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
    },
    {
      label: 'Roles',
      roles: 'role.view',
      routerLink: '/roles/role-list',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
    },
    {
      label: 'Users',
      roles: 'user.view',
      routerLink: '/admin/sub-company-users',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
    },
    {
      label: 'Licenses',
      roles: 'licenses.create',
      routerLink: '/admin/license',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
    },
    {
      label: 'IDP Playground',
      roles: 'playground.enabled',
      routerLink: '/ocr-playground',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
    },
  ]
  if (envType === 'SDEX') {
    list = list.concat([
      {
        label: 'LR Templates',
        roles: 'lr.assign',
        routerLink: '/admin/admin-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'IBA',
        routerLink: '/iba',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/bank.svg'
      }]
    )
  }
  if (envType !== 'CLMS') {
    list.push({
      label: 'Preferences',
      routerLink: '/preferences',
      hideList: true,
      imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
    });
  }
  return list;
}

function checkDashboardCondition(userDetails: any, authService: any, materialEnabled: any = false): boolean {
  let noEsignPermission = userDetails?.disabledPermissions?.includes('e-sign-details');
  if (materialEnabled && noEsignPermission) {
    return true;
  }
  let hasDocumentAccess = authService.documentVaultAccess();
  if (!hasDocumentAccess) {
    return false;
  }
  if (userDetails?.documentVault?.isExists || materialEnabled) {
    if (noEsignPermission ||
      (!noEsignPermission && userDetails?.eSignSelfLink)) {
      return true;
    } else if (!noEsignPermission && userDetails?.eSignSelfLink === undefined) {
      return false;
    }
  }
  return false;
}

export function companySideBarList(envType: string, isAdmin: boolean, isPrimary: boolean, userDetails: any, authService: any, materialEnabled: boolean, tgsrtcEnabled: boolean, entityType: any, prefs: any = {}, isDamsHost: boolean) {
  const docVaultPrefs = prefs?.documentVault || {};
  const studentCertEnabled = !!docVaultPrefs?.studentCertificate;
  const sscStudentCertEnabled = !!docVaultPrefs?.sscStudentCertificate;
  const biecStudentCertEnabled = !!docVaultPrefs?.bieStudentCertificate;

  if (envType === 'SDEX' || !envType) {
    return [
      {
        label: 'Dashboard',
        roles: '',
        routerLink: '/admin/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'Packages',
        roles: 'package.view',
        modules: 'package.enabled',
        routerLink: '/packages/incoming',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Packages.svg'
      },
      {
        label: ' Document Vault',
        roles: 'document.view',
        modules: 'documentVault.enabled',
        routerLink: 'document-vault',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      },
      {
        label: 'Network',
        roles: '',
        modules: 'company-contacts.enabled',
        routerLink: '/admin/contact-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
      },
      {
        label: 'Search Company',
        roles: '',
        modules: 'ekyc.enabled',
        routerLink: RouteConstants.EKycSearchList,
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg',
        addBorder: true
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
      },
      {
        label: 'Org. Structure',
        roles: 'company.view',
        modules: 'organizationStructure.enabled',
        routerLink: '/organization-structure',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'LR Templates',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/admin/company-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'LR List',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/lr-generation/generated-lrs',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-list.svg'
      },
      {
        label: 'Global Settings',
        roles: true,
        routerLink: '/admin/company-settings',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
      },
      {
        label: 'e-Way Bill',
        roles: 'ewaybill.view',
        modules: 'package.eWaybill',
        routerLink: '/eway-bill/credentials',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lock.svg'
      },
      {
        label: 'e-Invoice',
        roles: 'einvoice.view',
        modules: 'package.eInvoice',
        routerLink: '/einvoice',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/invoice.svg'
      }]
  }
  else if (envType === 'DAMS') {
    const damsSidebar = [
      {
        label: 'Dashboard',
        skipAccess: true,
        routerLink: checkDashboardCondition(userDetails, authService, materialEnabled) ? 'dams-dashboard' : '/admin/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'Org. Structure',
        roles: 'company.view',
        routerLink: '/organization-structure',
        modules: 'organizationStructure.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg'
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'Employee Register',
        routerLink: RouteConstants.EmployeeRegister,
        modules: 'tgsrtc.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'Business Partners',
        roles: 'mr-masterdata.view',
        // routerLink: RouteConstants.MaterailRegister,
        modules: 'material.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/icons8-partnership-100.png',
        subItems: [
          {
            label: 'Customers',
            roles: 'mr-outbound.view',
            routerLink: 'shipment/customers',
            modules: 'material.enabled',
            hideList: true,
            // imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
          },
          {
            label: 'Suppliers',
            roles: 'mr-inbound.view',
            routerLink: 'shipment/suppliers',
            modules: 'material.enabled',
            hideList: true,
            // imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
          },
          {
            label: 'Scrap Buyers',
            roles: 'mr-scrap.view',
            routerLink: 'shipment/scrap-buyers',
            modules: 'material.enabled',
            hideList: true,
            // imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
          },
          {
            label: 'Transporters',
            roles: 'mr-inbound.view,mr-outbound.view',
            routerLink: 'shipment/transportes',
            modules: 'material.enabled',
            hideList: true,
            // imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
          },
        ]
      },
      {
        label: 'Material Register',
        roles: 'mr-inbound.view,mr-outbound.view,mr-scrap.view',
        routerLink: RouteConstants.MaterailRegister,
        modules: 'material.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'Workflow Vault',
        roles: 'workflow-document.view',
        routerLink: RouteConstants.WorkflowDocument,
        modules: 'workFlow.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      // {
      //   label: 'Document Vault',
      //   roles: 'document.view',
      //   routerLink: 'document-vault',
      //   modules: 'documentVault.enabled',
      //   hideList: true,
      //   imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      // },
      // {
      //   label: 'Patient Reports',
      //   routerLink: RouteConstants.HospitalManagement,
      //   // modules: 'tgsrtc.enabled',
      //   hideList: true,
      //   imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      // },

      {
        label: 'Network',
        roles: 'guest-company.view',
        routerLink: '/contacts',
        modules: 'contractManagementSystem.enabled',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg'
      },
      {
        label: 'Contracts',
        roles: 'contracts.view',
        routerLink: 'contracts',
        modules: 'contractManagementSystem.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
      },
      {
        label: 'LR Templates',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/admin/company-templates-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
      },
      {
        label: 'LR List',
        roles: 'lr.view',
        modules: 'lr.enabled',
        routerLink: '/lr-generation/generated-lrs',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/lr-list.svg'
      },
      {
        label: 'Preferences',
        roles: '',
        routerLink: 'cms-preference',
        modules: 'contractManagementSystem.enabled',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
      },

      // {
      //   label: 'Student List',
      //   routerLink: 'student-list',
      //   modules: 'documentVault.studentCertificate',
      //   hideList: true,
      //   imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      // },
      {
        label: 'Certificates',
        roles: 'certificates',
        routerLink: 'student-file',
        modules: 'documentVault.studentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'SSC Certificates',
        routerLink: RouteConstants.SSCCertificates,
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      },
      {
        label: 'SSC Dashboard',
        routerLink: RouteConstants.SSCDashboard,
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'SSC Students',
        routerLink: 'student-list',
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.sscStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'Students List',
        routerLink: 'student-list',
        roles: 'ssc-certificate.view,ssc-certificate.edit',
        modules: 'documentVault.studentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'BIE Certificates',
        routerLink: RouteConstants.BIECertificates,
        roles: 'bie-certificate.view,bie-certificate.edit',
        modules: 'documentVault.bieStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg'
      },
      {
        label: 'BIE Dashboard',
        routerLink: RouteConstants.BIEDashboard,
        roles: 'bie-certificate.view,bie-certificate.edit',
        modules: 'documentVault.bieStudentCertificate',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
    ]
    if (entityType) {
      if (entityType === 'medical') {
        damsSidebar.push({
          label: 'Document Vault',
          roles: 'document.view',
          routerLink: 'document-vault',
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
        });
        damsSidebar.push({
          label: 'Patient Reports',
          routerLink: RouteConstants.HospitalManagement,
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });
        damsSidebar.push({
          label: 'Master Data',
          roles: 'document.view',
          routerLink: '/lookup',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
        });
      }
      if (entityType === 'medical' || entityType === 'waterBoard') {
        damsSidebar.push({
          label: entityType === 'medical' ? 'Patients' : 'Employee Register',
          routerLink: RouteConstants.WaterBoardEmployeeRegister,
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/lr-templates.svg'
        });
      }
      if (entityType === 'waterBoard' || entityType === 'nicdc') {
        damsSidebar.push({
          label: 'AI Assistant',
          routerLink: RouteConstants.Chatbot,
          modules: 'documentVault.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/chatbot.png'
        });
      }
    }
    if (!tgsrtcEnabled && entityType !== 'waterBoard' && !sscStudentCertEnabled && !studentCertEnabled && !biecStudentCertEnabled) {
      damsSidebar.push({
        label: 'Document Vault',
        roles: 'document.view',
        routerLink: 'document-vault',
        modules: 'documentVault.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      });
    }
    if (userDetails.primary) {
      damsSidebar.push({
        label: 'API Key',
        routerLink: RouteConstants.ApiKey,
        modules: 'apiKey.enabled',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
      });
      if (!isDamsHost) {
        damsSidebar.push({
          label: 'Global Settings',
          roles: '',
          modules: 'customUrl.customUrl',
          routerLink: '/admin/company-settings',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
        });
      }
    }
    // if(userDetails.isAdmin && !materialEnabled){
    //   damsSidebar.splice(4,0,
    //     {
    //       label: 'Master Data',
    //       roles: 'document.view',
    //       routerLink: '/lookup',
    //       hideList: true,
    //       imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
    //     }
    //   )
    // }
    if (['APBoard', 'Board'].includes(userDetails?.assignedTo[0]?.company?.enrollmentType)) {
      damsSidebar.push({
        label: 'Certificates',
        roles: '',
        routerLink: 'certificate-generation/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg'
      });
    }

    if (!materialEnabled && !tgsrtcEnabled && !entityType && !sscStudentCertEnabled && !studentCertEnabled && !biecStudentCertEnabled) {
      damsSidebar.push({
        label: 'Master Data',
        roles: 'document.view, workflow.view,workflow.delete,workflow.update,workflow.create',
        routerLink: '/lookup',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/master-data.svg'
      });
    }

    if (userDetails?.guestCompany && !userDetails?.company) {
      return [
        {
          label: 'Contracts',
          skipAccess: true,
          routerLink: 'contracts',
          modules: 'contractManagementSystem.enabled',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
        },
      ]
    }

    if (envType === 'DAMS') {
      damsSidebar.push({
        label: 'Notifications',
        skipAccess: true,
        routerLink: RouteConstants.AppNotifications,
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/notification.svg'
      });
    }
    
    return damsSidebar;
  }

  else if (envType === 'CLMS') {
    if (userDetails?.guestCompany && !userDetails?.company) {
      return [
        {
          label: 'Contracts',
          skipAccess: true,
          routerLink: 'contracts',
          hideList: true,
          imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
        },
      ]
    }
    return [
      {
        label: 'Dashboard',
        roles: '',
        routerLink: '/admin/dashboard',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Dashboard.svg'
      },
      {
        label: 'Org. Structure',
        roles: 'company.view',
        routerLink: '/organization-structure',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/OrgStructure.svg'
      },
      {
        label: 'Roles',
        roles: 'role.view',
        routerLink: '/roles/role-list',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Roles.svg',
      },
      {
        label: 'Users',
        roles: 'user.view',
        routerLink: '/admin/sub-company-users',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/Users.svg',
        addBorder: true
      },

      {
        label: 'Network',
        roles: 'guest-company.view',
        routerLink: '/contacts',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/Network.svg'
      },
      {
        label: 'Contracts',
        roles: 'contracts.view',
        routerLink: 'contracts',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/DocumentVoult.svg',
      },
      {
        label: 'Preferences',
        roles: true,
        routerLink: 'cms-preference',
        hideList: isAdmin,
        imgSrc: '../../../assets/Images/side-nav-bar/preferences1.png'
      },
      {
        label: 'Global Settings',
        roles: true,
        routerLink: '/admin/company-settings',
        hideList: true,
        imgSrc: '../../../assets/Images/side-nav-bar/settingsImage.svg'
      },
    ]
  }
  return [];
}
